import type { FaireProductEntity } from "../../entity_types/product";

export const p_2qa6367nzz: FaireProductEntity = {
  token: "p_2qa6367nzz",
  type: "product",
  name: "Garden Tomato Candle / Available in 5oz & 8oz",
  brandToken: "b_bdktycs6",
  brandName: "Na Nin",
  imageUrl:
    "https://cdn.faire.com/fastly/0a9fd1c479fed005215f4d86323ea7c89ef3d220d8ee557673985f5fcd93ddcf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8a38d097c957b8972b097198f704b86ccd2f8f7152569d17f1a0c3fbeb09d8d5.jpeg",
    "https://cdn.faire.com/fastly/2414e25d8132deda78e97fa1a061d17acabb3ef3b3c68d945bc9b4657ddc1a89.jpeg",
    "https://cdn.faire.com/fastly/555df80d49a5e3bd79c5626a3a29c6fa74d90b8199db9d2a4cd2954752bd2579.jpeg",
    "https://cdn.faire.com/fastly/0a3b7007114642e0f94f33dbfbaff2445cdef16b396b2a28899c01b05a4c85df.jpeg",
    "https://cdn.faire.com/fastly/079d70f8b36c52765cf8b4da00e930ace8d607c609a9046e4399ae9a28d7be84.jpeg",
    "https://cdn.faire.com/fastly/0892b17170952919202d7f6507f0245092568dd49695bfcdf1f8a61667a1b097.jpeg",
    "https://cdn.faire.com/fastly/cf88a5a86f123824d2135f0b13d9c1decd9f15032b1668819422e5a58d1bf598.jpeg",
  ],
  priceDollars: 13,
  description:
    "Earthy tomato vine and spicy black pepper is a vibrant scent to warm your living space\n\nMy grandfather in South Carolina had over a hundred tomato plants that ended up sprouting into hundreds more over my grandparents’ property, and we would call them his ‘wild tomatoes.’ He would take such pride in these plants and in the summer he looked forward to delivering his tomatoes to residents in the small town he and my grandmother lived in.\n\nAlso available as part of a votive candle set\n\nMade in Richmond, VA\n",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:52.494Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
